export enum Steps {
  GENERAL = 'settings.twofactor.steps.general',
  ENABLE = 'settings.twofactor.steps.enable',
  DISABLE = 'settings.twofactor.steps.disable',
  TOKEN = 'settings.twofactor.steps.token',
  BACK = 'settings.twofactor.steps.back',
}
